import { render, staticRenderFns } from "./taskCard.vue?vue&type=template&id=9e0a82b4&scoped=true"
import script from "./taskCard.vue?vue&type=script&lang=js"
export * from "./taskCard.vue?vue&type=script&lang=js"
import style0 from "./taskCard.vue?vue&type=style&index=0&id=9e0a82b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e0a82b4",
  null
  
)

export default component.exports